// import React, { useState } from 'react';
// import { Menu, X, Bell, Search, User } from 'lucide-react';
// import { useTheme } from '../../context/ThemeContext';
// import { Sun, Moon } from 'lucide-react';

// const Header = ({ toggleSidebar, isSidebarOpen }) => {
//   const { isDark, toggleTheme } = useTheme();
//   const [searchTerm, setSearchTerm] = useState('');

//   return (
//     <header className="sticky top-0 z-40 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 shadow-sm">
//       <div className="px-4 py-3 flex items-center justify-between">
//         <div className="flex items-center space-x-4">
//           <button
//             onClick={toggleSidebar}
//             className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
//           >
//             {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
          
//           <div className="flex items-center space-x-2">
//             <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
//               <span className="text-white text-2xl">🚢</span>
//             </div>
//             <div>
//               <h1 className="text-xl font-bold text-gray-900 dark:text-white">
//                 Ship Maintenance Prediction
//               </h1>
//               <p className="text-sm text-gray-500 dark:text-gray-400">
//                 Dockyard Total Solution (Pvt) Ltd
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="flex items-center space-x-4">
//           <div className="relative hidden md:block">
//             <input
//               type="text"
//               placeholder="Search vessels, maintenance..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="pl-10 pr-4 py-2 w-64 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <Search className="absolute left-3 top-2.5 text-gray-400" size={20} />
//           </div>

//           <button
//             onClick={toggleTheme}
//             className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
//           >
//             {isDark ? <Sun size={22} /> : <Moon size={22} />}
//           </button>

//           <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 relative">
//             <Bell size={22} />
//             <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
//           </button>

//           <div className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer">
//             <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
//               <User size={18} className="text-white" />
//             </div>
//             <div className="hidden md:block">
//               <p className="text-sm font-medium text-gray-900 dark:text-white">Admin</p>
//               <p className="text-xs text-gray-500 dark:text-gray-400">System Manager</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState } from 'react';
import { 
  Menu, 
  X, 
  Bell, 
  Search, 
  User, 
  Sun, 
  Moon,
  Ship,
  ChevronDown,
  Settings,
  LogOut,
  HelpCircle,
  BarChart3,
  Calendar,
  FileText,
  Users
} from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { Menu as HeadlessMenu, Transition } from '@headlessui/react';

const Header = ({ toggleSidebar, isSidebarOpen }) => {
  const { isDark, toggleTheme } = useTheme();
  const [searchTerm, setSearchTerm] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  const userMenuItems = [
    { icon: <User size={18} />, label: 'My Profile' },
    { icon: <Settings size={18} />, label: 'Settings' },
    { icon: <HelpCircle size={18} />, label: 'Help & Support' },
    { icon: <LogOut size={18} />, label: 'Logout', color: 'text-red-600 dark:text-red-400' },
  ];

  const notifications = [
    { id: 1, title: 'Maintenance Scheduled', desc: 'MV Ocean King - Dry Dock in 3 days', time: '10 min ago', unread: true },
    { id: 2, title: 'New Vessel Added', desc: 'MV Blue Wave registered successfully', time: '1 hour ago', unread: true },
    { id: 3, title: 'Report Generated', desc: 'Monthly maintenance report ready', time: '2 hours ago', unread: false },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left Section */}
          <div className="flex items-center space-x-3 lg:space-x-4">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 lg:hidden"
              aria-label="Toggle sidebar"
            >
              {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            {/* Logo */}
            <div className="flex items-center space-x-2 lg:space-x-3">
              <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg">
                <Ship className="text-white" size={24} />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-lg lg:text-xl font-bold text-gray-900 dark:text-white whitespace-nowrap">
                  Dockyard Prediction
                </h1>
                <p className="text-xs lg:text-sm text-gray-500 dark:text-gray-400">
                  Maintenance System
                </p>
              </div>
            </div>
          </div>

          {/* Center Section - Search */}
          <div className="flex-1 max-w-2xl mx-4">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Search vessels, maintenance, reports..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                <kbd className="inline-flex items-center px-2 py-1 border border-gray-300 dark:border-gray-600 rounded text-xs font-sans font-medium text-gray-400 bg-gray-100 dark:bg-gray-800">
                  ⌘K
                </kbd>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-1 lg:space-x-2">
            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="hidden sm:flex p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 items-center justify-center"
              aria-label="Toggle theme"
            >
              {isDark ? <Sun size={22} className="text-amber-500" /> : <Moon size={22} className="text-gray-600" />}
            </button>

            {/* Quick Actions */}
            <div className="hidden md:flex items-center space-x-1">
              <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" title="Calendar">
                <Calendar size={20} className="text-gray-600 dark:text-gray-400" />
              </button>
              <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" title="Reports">
                <FileText size={20} className="text-gray-600 dark:text-gray-400" />
              </button>
              <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" title="Analytics">
                <BarChart3 size={20} className="text-gray-600 dark:text-gray-400" />
              </button>
              <button className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" title="Users">
                <Users size={20} className="text-gray-600 dark:text-gray-400" />
              </button>
            </div>

            {/* Notifications */}
            <div className="relative">
              <button
                onClick={() => setShowNotifications(!showNotifications)}
                className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 relative"
                aria-label="Notifications"
              >
                <Bell size={22} className="text-gray-600 dark:text-gray-400" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>

              {/* Notifications Dropdown */}
              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 sm:w-96 bg-white dark:bg-gray-900 rounded-lg shadow-xl border border-gray-200 dark:border-gray-800 z-50">
                  <div className="p-4 border-b border-gray-200 dark:border-gray-800">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold text-gray-900 dark:text-white">Notifications</h3>
                      <span className="text-xs text-blue-600 dark:text-blue-400 cursor-pointer">Mark all as read</span>
                    </div>
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    {notifications.map((notification) => (
                      <div
                        key={notification.id}
                        className={`p-4 border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 ${
                          notification.unread ? 'bg-blue-50 dark:bg-blue-900/10' : ''
                        }`}
                      >
                        <div className="flex items-start space-x-3">
                          <div className={`w-2 h-2 mt-2 rounded-full ${
                            notification.unread ? 'bg-blue-500' : 'bg-gray-300 dark:bg-gray-600'
                          }`}></div>
                          <div className="flex-1">
                            <p className="font-medium text-gray-900 dark:text-white">{notification.title}</p>
                            <p className="text-sm text-gray-600 dark:text-gray-400">{notification.desc}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">{notification.time}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-4 text-center border-t border-gray-200 dark:border-gray-800">
                    <a href="/notifications" className="text-sm text-blue-600 dark:text-blue-400 hover:underline">
                      View all notifications
                    </a>
                  </div>
                </div>
              )}
            </div>

            {/* User Menu */}
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
                aria-label="User menu"
              >
                <div className="w-8 h-8 lg:w-9 lg:h-9 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-full flex items-center justify-center">
                  <User size={18} className="text-white" />
                </div>
                <div className="hidden lg:block text-left">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">John Smith</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">Admin</p>
                </div>
                <ChevronDown size={16} className="hidden lg:block text-gray-400" />
              </button>

              {/* User Dropdown Menu */}
              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 sm:w-56 bg-white dark:bg-gray-900 rounded-lg shadow-xl border border-gray-200 dark:border-gray-800 z-50">
                  <div className="p-4 border-b border-gray-200 dark:border-gray-800">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-full flex items-center justify-center">
                        <User size={20} className="text-white" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">John Smith</p>
                        <p className="text-sm text-gray-500 dark:text-gray-400">admin@dockyard.com</p>
                      </div>
                    </div>
                  </div>
                  <div className="py-2">
                    {userMenuItems.map((item, index) => (
                      <a
                        key={index}
                        href="#"
                        className={`flex items-center space-x-3 px-4 py-3 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 ${
                          item.color || 'text-gray-700 dark:text-gray-300'
                        }`}
                      >
                        {item.icon}
                        <span>{item.label}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Bottom Bar */}
        <div className="flex md:hidden items-center justify-between mt-3 pt-3 border-t border-gray-200 dark:border-gray-800">
          <button
            onClick={toggleTheme}
            className="flex-1 flex items-center justify-center p-2 text-gray-600 dark:text-gray-400"
          >
            {isDark ? <Sun size={20} /> : <Moon size={20} />}
          </button>
          <button className="flex-1 flex items-center justify-center p-2 text-gray-600 dark:text-gray-400">
            <Calendar size={20} />
          </button>
          <button className="flex-1 flex items-center justify-center p-2 text-gray-600 dark:text-gray-400">
            <FileText size={20} />
          </button>
          <button className="flex-1 flex items-center justify-center p-2 text-gray-600 dark:text-gray-400">
            <BarChart3 size={20} />
          </button>
        </div>
      </div>

      {/* Click outside handlers */}
      {(showUserMenu || showNotifications) && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => {
            setShowUserMenu(false);
            setShowNotifications(false);
          }}
        />
      )}
    </header>
  );
};

export default Header;